import styles from "./OrganisationProfileAreas.module.scss";
import { useContext, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { AuthContext } from "../../context/AuthContext";
import { useEnumStore } from "../../store/enumStore";
import { EventInterestsSkillsSection } from "../EventInterestsSkillsSection/EventInterestsSkillsSection";

interface OrganisationAreasData {
  areas: string[];
}

export const OrganisationProfileAreas = () => {
  const interests = useEnumStore((state) => state.interests);
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("AuthContext must be used within an AuthProvider");
  }

  const { currentUser, editUser } = authContext;

  const [dialogOpen, setDialogOpen] = useState(false);
  const [organisationData, setOrganisationData] = useState<OrganisationAreasData>({
    areas: ((currentUser?.userData as any)?.areas || []).map((id: number) => String(id)),
  });

  useEffect(() => {
    if (currentUser) {
      const userData = currentUser.userData as any;
      setOrganisationData({ areas: (userData?.areas || []).map((id: number) => String(id)) });
    }
  }, [currentUser]);

  const handleCheckboxToggle = (value: string) => {
    const strValue = String(value);
    const alreadyExists = organisationData?.areas.includes(strValue);
    if (alreadyExists) {
      setOrganisationData((prevState) => ({
        ...prevState,
        areas: prevState.areas.filter((item) => item !== strValue),
      }));
    } else {
      setOrganisationData((prevState) => ({
        ...prevState,
        areas: [...prevState.areas, strValue],
      }));
    }
  };

  const handleEditConfirm = () => {
    const dataToSend = {
      // areas are already strings, backend expects strings
      areas: organisationData.areas,
    };
    editUser(dataToSend, "organisation");
    if (dialogOpen) {
      setDialogOpen(false);
    }
  };

  const handleClose = () => {
    setDialogOpen(false);
    const userData = currentUser?.userData as any;
    setOrganisationData({ areas: (userData?.areas || []).map((id: number) => String(id)) });
  };

  return (
    <>
      <div className={styles.areas}>
        <h3>Okruhy</h3>
        {organisationData?.areas?.length === 0 && (
          <p>Zatím nemáte vybrané žádné oblasti.</p>
        )}
        {organisationData?.areas?.length > 0 && (
          <EventInterestsSkillsSection
            title=""
            items={interests as any}
            selectedIds={organisationData.areas}
            editMode={false}
            userType="organisation"
            type="interests"
          />
        )}
        <Button variant="contained" onClick={() => setDialogOpen(true)}>
          Upravit okruhy
        </Button>
      </div>
      <Dialog
        open={dialogOpen}
        onClose={() => handleClose()}
        aria-labelledby="profile-dialog-title"
        maxWidth="xl"
        className={styles.dialog}
      >
        <DialogTitle id="profile-dialog-title" className={styles.dialogTitle}>
          Upravit okruhy
        </DialogTitle>
        <DialogContent className={styles.dialogContent}>
          {dialogOpen && (
            <EventInterestsSkillsSection
              title=""
              items={interests as any}
              selectedIds={organisationData.areas}
              onToggle={handleCheckboxToggle}
              editMode={true}
              userType="organisation"
              showSubItems={true}
              type="interests"
            />
          )}
        </DialogContent>
        <DialogActions className={styles.dialogActions}>
          <Button variant="outlined" onClick={() => handleClose()}>
            Zrušit
          </Button>
          <Button variant="contained" onClick={() => handleEditConfirm()}>
            Potvrdit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

